export default __webpack_public_path__ + "static/media/trabalhar.3232cf97.svg";